import React, { FC, memo, useMemo } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import Link from '@src/components/vaults/StakeTokenLinks/Link';

import Tooltip from '@components/common/Tooltip';

import { CHAIN_ID, DEX_SCREENER_LINK } from '@constants/common/chain.constants';
import { DEBANK_PROFILE } from '@constants/common/common.constants';

import { CommonTokenDto } from '@dto/common/tokens.dto';

import useStyles from './styles.module';

interface Props {
  chainId: number;
  stakeToken: CommonTokenDto;
  dexFactoryName?: string;
  isPoolV3PositionOutRange?: boolean;
}

const V3_POOL_OUT_RANGE_TITLE =
  'The farm LP is out of range. Please run manual harvest to bring the farm back to the optimal range.';

const StakeTokenLinks: FC<Props> = ({
  chainId,
  stakeToken,
  dexFactoryName,
  isPoolV3PositionOutRange,
}) => {
  const { classes } = useStyles();

  const deBankInfoMap = useMemo(
    () => [
      {
        title: 'LP info: DeBank',
        href: `${DEBANK_PROFILE}/${stakeToken?.address}`,
      },
      {
        title: 'Chart: Dexscreener',
        href: `${DEX_SCREENER_LINK[chainId as CHAIN_ID]}${stakeToken?.address}`,
      },
    ],
    [chainId, stakeToken],
  );

  return (
    <>
      {isPoolV3PositionOutRange ? (
        <Tooltip title={V3_POOL_OUT_RANGE_TITLE}>
          <ErrorOutlineIcon className={classes.isOutOfRange} />
        </Tooltip>
      ) : (
        <Tooltip
          isInfo
          title={
            <div className={classes.tooltip}>
              <Typography variant="caption1">DEX: {dexFactoryName}</Typography>
              <div className={classes.box}>
                <div className={classes.box}>
                  {deBankInfoMap.map(({ title, href }) => (
                    <Link key={href} href={href} title={title} />
                  ))}
                </div>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default memo(StakeTokenLinks);
